var _rect, _rect2, _path, _rect3, _rect4, _rect5, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInBannerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 86,
    viewBox: "0 0 167 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 28,
    width: 20,
    height: 20,
    fill: "#DAD8DA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 28,
    width: 20,
    height: 48,
    fill: "#DAD8DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.184 37.7112L140.234 32.5799C140.012 32.3893 139.688 32.5612 139.688 32.869V43.1315C139.688 43.4393 140.012 43.6112 140.234 43.4205L146.184 38.2893C146.355 38.1424 146.355 37.858 146.184 37.7112Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 28,
    width: 84,
    height: 48,
    fill: "#EFEEEF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 52,
    width: 20,
    height: 24,
    fill: "#EFEEEF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    width: 140,
    height: 20,
    fill: "#DAD8DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167 24L-1.01328e-06 24",
    stroke: "#6E28FC",
    strokeDasharray: "3 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1844 9.71116L80.2344 4.57991C80.0125 4.38929 79.6875 4.56116 79.6875 4.86897V15.1315C79.6875 15.4393 80.0125 15.6112 80.2344 15.4205L86.1844 10.2893C86.3547 10.1424 86.3547 9.85804 86.1844 9.71116Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1844 37.7112L20.2344 32.5799C20.0125 32.3893 19.6875 32.5612 19.6875 32.869V43.1315C19.6875 43.4393 20.0125 43.6112 20.2344 43.4205L26.1844 38.2893C26.3547 38.1424 26.3547 37.858 26.1844 37.7112Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37 28L37 86",
    stroke: "#6E28FC",
    strokeDasharray: "3 3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129 28L129 86",
    stroke: "#6E28FC",
    strokeDasharray: "3 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInBannerIcon);
export default __webpack_public_path__ + "static/media/in-banner-icon.9686993d7b878b60285e2beefd2f65f3.svg";
export { ForwardRef as ReactComponent };